<script setup lang="ts">
import { ProductSize } from '~/lib/services/store/catalog/catalog.dtos'
import { ProductSizeType } from '~/lib/services/store/common.dto'

const props = defineProps<{
  sizes: ProductSize[]
  productId: string
}>()

defineEmits(['change-size'])

const { t } = useLocale()
const { format } = useFormatAmount()

const upsellingPrice = computed(() => {
  const sizeSelected = props.sizes.find(size => size.code === props.productId)
  if (sizeSelected?.id !== ProductSizeType.LARGE) {
    const largeSize = props.sizes.find(size => size.id === ProductSizeType.LARGE)
    const priceDifference = (largeSize?.price ?? 0) - (sizeSelected?.price ?? 0)

    return priceDifference > 0 ? format(priceDifference) : ''
  }
  return ''
})
</script>

<template>
  <section class="mt-4">
    <h2 class="text-lg font-bold md:text-3xl">{{ t('productDetail.sizes.title') }}</h2>

    <div class="my-4 flex flex-row flex-wrap gap-2">
      <ProductSizeItem
        v-for="size in sizes"
        :key="size.id"
        :size="size"
        :product-id="productId"
        :upselling-price="size.id === ProductSizeType.LARGE ? upsellingPrice : ''"
        @change-size="(id:string) => $emit('change-size', id)"
      />
    </div>
  </section>
</template>
